import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState } from "../store"

interface RegionState {
  Region: any[]
}

// Define the initial state using that type
const initialState: RegionState = {
  Region: [],
}

export const RegionSlice = createSlice({
  name: 'region',
  initialState,
  reducers: {
   
    setRegion: (state, action: PayloadAction<any[]>) => {
      state.Region = action.payload
    },
  },
})

export const {setRegion} = RegionSlice.actions

export const RegionList = (state: RootState) => state.region.Region ?? []

export default RegionSlice.reducer